export default __webpack_public_path__ + "static/media/elephant.62fcab57.webp";